import React, { useState } from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import PDFVisualisateur from "./PDFVisualisateur"; // Assuming you already have this component
import getTemporaryUrl from "../api/getTemporaryUrl";
import { getDocDataById } from "../models/DataFunctions";
import { useEffect } from "react";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import Modal1 from "../modals/Modal1";

const PDFModal = ({
  type,
  document,
  folder,
  children,
  onFetch,
  prefix,
  orgData,
  userData,
  setLoadingData,
  handleDeleteFile,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = async () => {
    await fetchPresignedUrls();
    setOpen(true);
  };

  const handleClose = async (fetch = true) => {
    setOpen(false);
    if (fetch) await onFetch();
  };

  const [pdfUrls, setPdfUrls] = useState([]);
  const [files, setFiles] = useState([]);

  const fetchPresignedUrls = async () => {
    if (folder && document) {
      setLoadingData(document.id);
      const token = await getOrRefreshFirebaseToken();
      await getTemporaryUrl(token, type, document.id, folder.id, prefix);
      folder = await getDocDataById("folder", folder.id);
      setLoadingData(null);
      if (type === "doc") {
        const doc = await getDocDataById("document", document.id);
        const files = doc.files || [];
        setFiles(files);
      } else if (type === "thermal") {
        const files = folder.thermal.files || [];
        setFiles(files);
      } else if (type === "modif_thermal") {
        const files = folder.modif_thermal.files || [];
        setFiles(files);
      } else if (type === "rapport") {
        const files = folder.rapport.files || [];
        setFiles(files);
      } else if (type === "rapport-payment") {
        let payment_id = document.id.split("-")[2];
        let paymentData = await getDocDataById("payment", payment_id);
        const files = paymentData.rapport_files || [];
        setFiles(files);
      } else if (type === "rapport-slot") {
        let slot_id = document.id.split("-")[2];
        let slotData = await getDocDataById("rapport_slot", slot_id);
        const files = slotData.files || [];
        setFiles(files);
      } else if (type === "rapport_architecte") {
        const files = folder.rapport_architecte.files;
        setFiles(files);
      }
    }
  };

  return (
    <div className={`${open ? "w-full " : "w-fit"}`}>
      {/* Button to open the modal */}
      <div onClick={handleOpen} className="h-fit w-full cursor-pointer">
        {children}
      </div>

      {open && (
        <Modal1 isOpen={open} onClose={handleClose}>
          {/* PDF Viewer */}
          <PDFVisualisateur
            document={document}
            folder={folder}
            type={type}
            files={files}
            orgData={orgData}
            handleDeleteFile={handleDeleteFile}
            onClose={handleClose}
            onUpdate={fetchPresignedUrls}
            userData={userData}
          ></PDFVisualisateur>
        </Modal1>
      )}
    </div>
  );
};

export default PDFModal;
